import { AvatarBlueprint } from '../types'

export const femaleAvatarBlueprint: AvatarBlueprint = {
    skeleton: {
        name: 'Female',
        fileUrl: '/avatars/female/skeleton.glb'
    },
    hairs: [
        {name: 'Hair1', fileUrl: '/avatars/female/hairs/hair-01.glb' },
        {name: 'Hair2', fileUrl: '/avatars/female/hairs/hair-02.glb' },
        {name: 'Hair3', fileUrl: '/avatars/female/hairs/hair-03.glb' },
        {name: 'Hair4', fileUrl: '/avatars/female/hairs/hair-04.glb' },
        {name: 'Hair5', fileUrl: '/avatars/female/hairs/hair-05.glb' }
    ],
    faces: [
        {name:'Face1', fileUrl: '/avatars/female/faces/face-01.glb' },
        {name:'Face2', fileUrl: '/avatars/female/faces/face-02.glb' }
    ],
    bodies: [
        { name:'Body1', fileUrl: '/avatars/female/bodies/body-01.glb' },
        { name:'Body2', fileUrl: '/avatars/female/bodies/body-02.glb' },
        { name:'Body3', fileUrl: '/avatars/female/bodies/body-03.glb' },
        { name:'Body4', fileUrl: '/avatars/female/bodies/body-04.glb' },
        { name:'Body5', fileUrl: '/avatars/female/bodies/body-05.glb' },
        { name:'Body6', fileUrl: '/avatars/female/bodies/body-06.glb' },
        { name:'Body7', fileUrl: '/avatars/female/bodies/body-07.glb' },
        { name:'Body8', fileUrl: '/avatars/female/bodies/body-08.glb' },
        { name:'Body9', fileUrl: '/avatars/female/bodies/body-09.glb' },
        { name:'Body10', fileUrl: '/avatars/female/bodies/body-10.glb' },
        { name:'Body11', fileUrl: '/avatars/female/bodies/body-11.glb' },
        { name:'Body12', fileUrl: '/avatars/female/bodies/body-12.glb' }
    ],
    legs: [
        { name:'Leg1',fileUrl: '/avatars/female/legs/leg-01.glb' },
        { name:'Leg2',fileUrl: '/avatars/female/legs/leg-02.glb' },
        { name:'Leg3',fileUrl: '/avatars/female/legs/leg-03.glb' },
        { name:'Leg4',fileUrl: '/avatars/female/legs/leg-04.glb' },
        { name:'Leg5',fileUrl: '/avatars/female/legs/leg-05.glb' },
        { name:'Leg6',fileUrl: '/avatars/female/legs/leg-06.glb' }
    ],
    feet: [
        {name:'Foot1', fileUrl: '/avatars/female/feet/foot-01.glb' },
        {name:'Foot2', fileUrl: '/avatars/female/feet/foot-02.glb' },
        {name:'Foot3', fileUrl: '/avatars/female/feet/foot-03.glb' },
        {name:'Foot4', fileUrl: '/avatars/female/feet/foot-04.glb' },
        {name:'Foot5', fileUrl: '/avatars/female/feet/foot-05.glb' },
        {name:'Foot6', fileUrl: '/avatars/female/feet/foot-06.glb' },
        {name:'Foot7', fileUrl: '/avatars/female/feet/foot-07.glb' }
    ],
    hands: [{ name:'Hand1',fileUrl: '/avatars/female/hands/hand-01.glb' }],
    glasses: [
        {name:'Glasses1', fileUrl: '/avatars/female/glasses/glass-01.glb' },
        {name:'Glasses2', fileUrl: '/avatars/female/glasses/glass-02.glb' },
        {name:'Glasses3', fileUrl: '/avatars/female/glasses/glass-03.glb' }
    ]
}
